// extracted by mini-css-extract-plugin
export default {"shimmer":"Tooltip_shimmer__4BOmU","dark_shimmer":"Tooltip_dark_shimmer__5cnDs","tooltip_btn":"Tooltip_tooltip_btn__67lHs","tooltip":"Tooltip_tooltip__ulDbL"};